import * as yup from 'yup'

export const schema = yup.object({
  userName: yup
    .string()
    .required('ユーザ名は必須です')
    .test('userName-alphanumeric-validation', 'ユーザ名は半角英数字で入力してください', (value: string) => {
      return /^[a-zA-Z0-9]+$/.test(value)
    }),

  email: yup
    .string()
    .required('メールアドレスは必須です')
    .email('正しいメールアドレスを入力してください'),

  cdmNo: yup
    .string()
    .nullable()
    .test('cdmNo-is16digits', 'cdm番号は16桁の半角数字で入力してください', (value: string) => {
      if (!value) return true
      return /^\d{16}$/.test(value)
    }),
  
  encryptedDamtomoId: yup
    .string()
    .test('encryptedDamtomoId-alphanumeric-validation', '暗号化されたダムともIDは半角英数字で入力してください', (value: string) => {
      return /^[a-zA-Z0-9]+$/.test(value)
    }),
  
  shukeiId: yup
    .string()
    .required('精密集計のユーザ名は必須です')
    .test('shukeiId-alphanumeric-validation', '精密集計のユーザ名は半角英数字で入力してください', (value: string) => {
      return /^[a-zA-Z0-9]+$/.test(value)
    }),
})
